import { gql } from '@apollo/client';

export const CREATE_CURRENCY_MUTATION = gql`
  mutation createCurrency($name: String!, $code: String!, $symbol: String!) {
    createCurrency(name: $name, code: $code, symbol: $symbol) {
      currency {
        code
        id
        name
        symbol
      }
    }
  }
`;

export const UPDATE_CURRENCY_MUTATION = gql`
  mutation editCurrency(
    $id: Int!
    $name: String
    $code: String
    $symbol: String
  ) {
    editCurrency(id: $id, name: $name, code: $code, symbol: $symbol) {
      currency {
        code
        id
        name
        symbol
      }
    }
  }
`;
